// firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database'; // <-- 1. Import getDatabase

const firebaseConfig = {
  apiKey: "AIzaSyDY4-xEiAfHiGW2PLfc_CHQQgGOc2Wj_8I",
  authDomain: "coursehub-282e6.firebaseapp.com",
  databaseURL: "https://coursehub-282e6-default-rtdb.firebaseio.com",
  projectId: "coursehub-282e6",
  storageBucket: "coursehub-282e6.appspot.com",
  messagingSenderId: "833150848272",
  appId: "1:833150848272:web:f86914737748b0ec3d2995",
  measurementId: "G-C11Y97KMBQ"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getDatabase(app); // <-- 2. Initialize the database

export { auth, db }; // <-- 3. Export db